// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import Centered from 'layout/Centered';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '@tls/treact-ui';
import { IconLoading } from '@tls/treact-ui/icons';

type Props = {
  label?: string;
  spinner?: boolean;
};

export default function CenteredLoader({ label, spinner }: Readonly<Props>) {
  const { t } = useTranslation();
  return <Centered $width={70}>{spinner ? <IconLoading /> : <Loader label={label ?? t('loading')} />}</Centered>;
}
